'use strict';

// libraries


import 'dispatcher';

import 'gsap/TweenMax';
import 'ThrowPropsPlugin';

// utilities
import './utilities/outliner.view';


// components
import './content/content-more.component';
import './content/view-text.component';
import './content/view-content.component';
import './content/career.component';
import './decor/mask-light.component';
import './decor/main-top-video.component';
import './decor/marquee-view.component';
import './decor/view-slider.component';
import './decor/flash-view.component';
import './decor/comparison.component';
import './decor/clap-view.component';
import './form/field-focus.component';
import './form/checkbox.component';
import './form/textarea-autosize.component';
import './form/file.component';
import './form/select.component';
import './form/form.component';
import './audio/audio-player.component';
import './audio/multi-audio.component';
import './utilities/yotube-video.component';
import './utilities/spoiler.component';
import './utilities/privacy.component';
import './map/google-map.component';
import './drag-slider/slider.component';
// import './drag-slider/slider-button.component';
// import './drag-slider/slider-control.component';


// modules
import resizeView      from './resize/resize.view';
import loader          from './navigation/loader-css.view';
import router          from './navigation/router.view';
import template        from './navigation/template.view';
import menu            from './menu/menu.view';
import scrl            from './scroll/scrl.view';
import scrollTo        from './scroll/scroll-to.view';
import popupClose      from './popup/popup-close.view';
import popupControls   from './popup/popup-controls.view';
import popup           from './popup/popup.view';



require('domready')(() => {
  resizeView.init();
  loader.init();
  router.init();
  template.init();
  menu.init();
  scrl.init();
  scrollTo.init();
  popupClose.init();
  popupControls.init();
  popup.init();
});